/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestUniswapV2Pair extends Contract<ITestUniswapV2Pair> {
  getReserves: Call<() => { reserve0_: BigNumber, reserve1_: BigNumber, blockTimestampLast_: BigNumber }, ITestUniswapV2Pair>
  'getReserves()': Call<() => { reserve0_: BigNumber, reserve1_: BigNumber, blockTimestampLast_: BigNumber }, ITestUniswapV2Pair>
  kLast: Call<() => BigNumber, ITestUniswapV2Pair>
  'kLast()': Call<() => BigNumber, ITestUniswapV2Pair>
  token0: Call<() => string, ITestUniswapV2Pair>
  'token0()': Call<() => string, ITestUniswapV2Pair>
  token1: Call<() => string, ITestUniswapV2Pair>
  'token1()': Call<() => string, ITestUniswapV2Pair>
  totalSupply: Call<() => BigNumber, ITestUniswapV2Pair>
  'totalSupply()': Call<() => BigNumber, ITestUniswapV2Pair>
}

let ITestUniswapV2PairBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestUniswapV2PairBytecode = '0x';
}

// prettier-ignore
export const ITestUniswapV2Pair = contract<ITestUniswapV2Pair>(ITestUniswapV2PairBytecode)`
  function getReserves() view returns (uint112 reserve0_, uint112 reserve1_, uint32 blockTimestampLast_)
  function kLast() view returns (uint256 kLast_)
  function token0() view returns (address token0_)
  function token1() view returns (address token1_)
  function totalSupply() view returns (uint256 supply_)
`;